import {
  IPaxes,
  TArrayOfVacationTypes
} from 'modules/common/common.types'

const MAX_TOTAL_PAX: number = 9

const PAX: IPaxes = {
  ADULT: [1, 9],
  CHILD: [0, 9],
  INFANT: [0, 9],
  SENIOR: [0, 9]
}

const VACATION_GROUPS: TArrayOfVacationTypes[] = [

  ['BEACH', 'FAMILY', 'SPA', 'CITY', 'YOUNG_VACATION'],
  ['TOUR'],
  ['CIVIL_MARRIAGE'],
  ['CAR_INCLUDED']
]

enum QueryTypes {
  'comparePackage' = 'COMPARE_PACKAGE',
  'package' = 'PACKAGE',
  'flight' = 'FLIGHT'
}

enum SegmentIndexes {
  'firstSegment',
  'secondSegment'
}

enum SearchPendingsNames {
  'getCountries',
  'getAndSetCountries',
  'getCities',
  'getAndSetCities',
  'bestDeals',
  'getDepartureDatesByCountry',
  'getAndSetDepartureDatesByCountry',
  'getReturnDatesByCountry',
  'getAndSetReturnDatesByCountry'
}

enum SearchResultTypes {
  SEARCH_HAS_BEGUN = 'SEARCH_HAS_BEGUN',
  DEALS_POST_PROCESSED = 'DEALS_POST_PROCESSED',
  SUPPLIERS_RESPONDED = 'SUPPLIERS_RESPONDED'
}

export {
  MAX_TOTAL_PAX,
  PAX,
  QueryTypes,
  SegmentIndexes,
  SearchResultTypes,
  VACATION_GROUPS,
  SearchPendingsNames
}
